import { render } from "./ProjectStructureSetBuilderPage.vue?vue&type=template&id=1a333a12&scoped=true"
import script from "./ProjectStructureSetBuilderPage.vue?vue&type=script&lang=js"
export * from "./ProjectStructureSetBuilderPage.vue?vue&type=script&lang=js"

import "./ProjectStructureSetBuilderPage.vue?vue&type=style&index=0&id=1a333a12&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a333a12"]])

export default __exports__